export class TableMaintenanceConfig {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tableFormat",
            "baseName": "tableFormat",
            "type": "string",
            "format": ""
        },
        {
            "name": "compactionEnabled",
            "baseName": "compactionEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "compactionScheduleHours",
            "baseName": "compactionScheduleHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactionStrategy",
            "baseName": "compactionStrategy",
            "type": "CompactionStrategy",
            "format": ""
        },
        {
            "name": "compactionTargetFileSizeMb",
            "baseName": "compactionTargetFileSizeMb",
            "type": "number",
            "format": ""
        },
        {
            "name": "compactionSortColumns",
            "baseName": "compactionSortColumns",
            "type": "Array<SortColumnSpec>",
            "format": ""
        },
        {
            "name": "compactionZorderColumns",
            "baseName": "compactionZorderColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "snapshotRetentionEnabled",
            "baseName": "snapshotRetentionEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "snapshotRetentionScheduleHours",
            "baseName": "snapshotRetentionScheduleHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "snapshotRetainDays",
            "baseName": "snapshotRetainDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "snapshotMinSnapshots",
            "baseName": "snapshotMinSnapshots",
            "type": "number",
            "format": ""
        },
        {
            "name": "orphanDeletionEnabled",
            "baseName": "orphanDeletionEnabled",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "orphanDeletionScheduleHours",
            "baseName": "orphanDeletionScheduleHours",
            "type": "number",
            "format": ""
        },
        {
            "name": "orphanDeletionOlderThanDays",
            "baseName": "orphanDeletionOlderThanDays",
            "type": "number",
            "format": ""
        },
        {
            "name": "updatedAt",
            "baseName": "updatedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return TableMaintenanceConfig.attributeTypeMap;
    }
    constructor() {
    }
}
